import * as fromDatatype from '../datatype-library/index';

export interface bl_pos_terminal_drawer_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_status: fromDatatype.VarcharDatatypeInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  drawer_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_close: fromDatatype.TimestampTzDatatypeInterface;
  current_terminal_device_guid: fromDatatype.GuidDataFieldInterface;
  cashier_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  session_name: fromDatatype.VarcharDatatypeInterface;
  drawer_name: fromDatatype.VarcharDatatypeInterface;
  device_name: fromDatatype.VarcharDatatypeInterface;
  cashier_name: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_pos_terminal_drawer_txn_hdr_RowClass implements bl_pos_terminal_drawer_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_status: fromDatatype.VarcharDatatypeInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  drawer_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_close: fromDatatype.TimestampTzDatatypeInterface;
  current_terminal_device_guid: fromDatatype.GuidDataFieldInterface;
  cashier_guid: fromDatatype.GuidDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  session_name: fromDatatype.VarcharDatatypeInterface;
  drawer_name: fromDatatype.VarcharDatatypeInterface;
  device_name: fromDatatype.VarcharDatatypeInterface;
  cashier_name: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
}
